import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { SocketContext } from "../context/SocketProvider";
import { useLanguage } from "../context/LanguageContext";

/**
 * PlayerIdBadge — persistent bottom-right badge visible across all game pages
 * when Data Collection is ON and a Player ID has been assigned.
 */
const PlayerIdBadge = () => {
  const { playMode, userId, badgeRole, consentSeen, role } = useContext(SocketContext);
  const { t } = useLanguage();
  const location = useLocation();

  if (playMode !== "game" || !userId || !consentSeen) return null;

  // Use badgeRole if available, otherwise fall back to current role
  // This handles the case when the badge is shown before badgeRole is set
  const effectiveRole = badgeRole || role;
  
  // Yellow color for id Badge
  const goldPages = ["/points", "/aiwaiting", "/seeresults"];
  const textColor = goldPages.includes(location.pathname) ? "text-yellow400" : (effectiveRole === "describer" ? "text-pink400" : "text-blue400");

  return (
    <div className={`fixed bottom-2 right-0 z-50 px-4 py-1 ${textColor} font-normal leading-none font-['Gabarito']`} style={{ fontSize: "17px" }}>
      {t("badge.dataCollection", "Data Collection: ON")}
      &nbsp;&nbsp;
      {t("badge.playerId", "Player ID:")} {userId}
    </div>
  );
};

export default PlayerIdBadge;
